export default {
  dialogTitle: {
    notes: 'Title of the create shopping list dialog',
    message: 'Create shopping list',
  },
};
